function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "CONCEPT-FINAL",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "DEFAULT-STATE-Orders-NOT-selected",
  transform: "translate(-1070.000000, -298.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "total-sigma",
  transform: "translate(1070.000000, 298.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#CCCCCC",
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  fill: "#EDEDED",
  points: "11 4 5 4 5 5.571 7.581 8 5 10.445 5 12 11 12 11 11 6 11 9 8 6 5 11 5"
}))));

function SvgIconSigmaDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "total-sigma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSigmaDisabled);
export default __webpack_public_path__ + "static/media/icon_sigma_disabled.986559f9.svg";
export { ForwardRef as ReactComponent };